/* Casa de Diciembre · Regalos del pack como líneas propias del carrito (portado de EE. UU.).
   1) Al pulsar «Añadir al carrito» en un <product-form> cuya variante es un pack, añade en UNA llamada
      /cart/add el calendario + sus regalos (propiedad oculta _gift_for = id de la variante del pack).
   2) Tras cualquier cambio de carrito (/cart/add|change|update|clear), recalcula los regalos que tocan
      según las líneas del pack y ajusta SOLO las líneas con _gift_for. Las líneas sin _gift_for no se tocan.
   El precio 0 € lo ponen los descuentos automáticos «Regalos pack – N calendario(s)» (BXGY) de Shopify. */
(function () {
  if (window.__cddGiftSync) return;
  window.__cddGiftSync = true;

  // Productos regalo (5,00 € sueltos): papel, tarjetas, librito digital, bolsa de terciopelo
  var WRAP = 57412936106324, CARDS = 57412936565076, STORY = 57412936761684, BAG = 57412936991060;
  // variante del pack -> regalos por unidad del pack
  var MAP = {
    '57412942135636': [[WRAP, 1], [CARDS, 1], [STORY, 1], [BAG, 1]],   // 1 calendario + 4 regalos
    '57412942168404': [[WRAP, 2], [CARDS, 2], [STORY, 2], [BAG, 2]],   // 2 calendarios + 4 regalos cada uno
    '57412942201172': [[WRAP, 3], [CARDS, 3], [STORY, 3], [BAG, 3]]    // 3 calendarios + 4 regalos cada uno
  };
  var PROP = '_gift_for';
  window.CDDGifts = { map: MAP, prop: PROP };

  var origFetch = window.fetch.bind(window);
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function jpost(path, body) {
    return origFetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* ---------- 1) Añadir pack + regalos en una sola llamada ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !form.closest('product-form')) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    var vid = String(idInput.value);
    var gifts = MAP[vid];
    if (!gifts) return;
    var qInput = form.querySelector('input[name="quantity"]');
    var qty = Math.max(1, parseInt(qInput && qInput.value, 10) || 1);
    var box = document.createElement('div');
    box.setAttribute('data-cdd-gift-inputs', '');
    box.hidden = true;
    var html = '';
    function inp(n, v) { html += '<input type="hidden" name="' + n + '" value="' + v + '">'; }
    // Shopify pone arriba la última línea añadida: regalos en orden inverso y el pack al final,
    // para que el cajón muestre el pack primero y debajo sus regalos.
    var n = 0;
    gifts.slice().reverse().forEach(function (g) {
      inp('items[' + n + '][id]', g[0]);
      inp('items[' + n + '][quantity]', g[1] * qty);
      inp('items[' + n + '][properties][' + PROP + ']', vid);
      n++;
    });
    inp('items[' + n + '][id]', vid);
    inp('items[' + n + '][quantity]', qty);
    box.innerHTML = html;
    form.appendChild(box);
    // Mientras el tema lee el FormData, quitamos id/quantity sueltos para que no se añada el pack dos veces.
    idInput.setAttribute('data-cdd-name', 'id');
    idInput.removeAttribute('name');
    if (qInput) { qInput.setAttribute('data-cdd-name', 'quantity'); qInput.removeAttribute('name'); }
    setTimeout(function () {
      idInput.setAttribute('name', 'id');
      if (qInput) qInput.setAttribute('name', 'quantity');
      if (box.parentNode) box.parentNode.removeChild(box);
    }, 0);
  }, true);

  /* ---------- 2) Sincronizar regalos tras cualquier cambio de carrito ---------- */
  function upsellIds() {
    var out = {};
    document.querySelectorAll('cart-drawer cart-drawer-upsell[data-id], cart-drawer cart-drawer-gift[data-id]').forEach(function (el) {
      out[String(el.dataset.id)] = true;
    });
    return out;
  }
  function plan(cart) {
    var want = {};   // gift_for|variant -> qty
    var have = {};   // gift_for|variant -> [lines]
    (cart.items || []).forEach(function (it) {
      var gf = it.properties && it.properties[PROP];
      if (gf) {
        var k = gf + '|' + it.variant_id;
        (have[k] = have[k] || []).push(it);
        return;
      }
      var gifts = MAP[String(it.variant_id)];
      if (!gifts) return;
      gifts.forEach(function (g) {
        var k2 = it.variant_id + '|' + g[0];
        want[k2] = (want[k2] || 0) + g[1] * it.quantity;
      });
    });
    var updates = {}, nUpd = 0, adds = [];
    Object.keys(have).forEach(function (k) {
      var target = want[k] || 0;
      var sum = have[k].reduce(function (a, l) { return a + l.quantity; }, 0);
      // Shopify puede partir una línea en dos (parte con descuento, parte sin): si la suma cuadra, no se toca.
      if (sum === target) return;
      have[k].forEach(function (line, i) {
        var q = i === 0 ? target : 0;
        if (line.quantity !== q) { updates[line.key] = q; nUpd++; }
      });
    });
    Object.keys(want).forEach(function (k) {
      if (have[k] || !want[k]) return;
      var p = k.split('|'), props = {};
      props[PROP] = p[0];
      adds.push({ id: Number(p[1]), quantity: want[k], properties: props });
    });
    adds.reverse();
    // Como Shrine en el tema en vivo: si al quitar el pack solo quedarían upsells del cajón
    // (Protección de envío), se quitan también y el carrito queda vacío.
    var ups = upsellIds();
    var hadGifts = Object.keys(have).length > 0;
    var regular = (cart.items || []).some(function (it) {
      return !(it.properties && it.properties[PROP]) && !ups[String(it.variant_id)];
    });
    if (hadGifts && !regular) {
      (cart.items || []).forEach(function (it) {
        if (ups[String(it.variant_id)] && updates[it.key] !== 0) { updates[it.key] = 0; nUpd++; }
      });
    }
    return { updates: nUpd ? updates : null, adds: adds };
  }

  function sectionTargets() {
    var out = [], seen = {};
    ['cart-drawer-items', 'cart-items'].forEach(function (tag) {
      document.querySelectorAll(tag).forEach(function (el) {
        if (typeof el.getSectionsToRender !== 'function') return;
        var list;
        try { list = el.getSectionsToRender(); } catch (e) { return; }
        (list || []).forEach(function (s) {
          if (!s || !s.section || seen[s.id + s.section]) return;
          seen[s.id + s.section] = true;
          out.push({ id: s.id, section: s.section, selector: s.selector, el: el });
        });
      });
    });
    return out;
  }
  function innerOf(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var n = doc.querySelector(selector) || doc.querySelector('.shopify-section') || doc.body;
    return n ? n.innerHTML : '';
  }
  function rerender(cart) {
    var targets = sectionTargets();
    var empty = !cart || cart.item_count === 0;
    document.querySelectorAll('cart-drawer, cart-drawer-items, cart-items, #main-cart-footer').forEach(function (el) {
      el.classList.toggle('is-empty', empty);
    });
    if (!targets.length) return Promise.resolve();
    var ids = targets.map(function (t) { return t.section; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
    // Ojo: sin cabecera Accept JSON; en /products/... Shopify devolvería el JSON del producto en vez de las secciones.
    return origFetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (secs) {
        if (!secs || typeof secs !== 'object') return;
        targets.forEach(function (t) {
          var host = document.getElementById(t.id);
          if (!host || !secs[t.section]) return;
          var node = (t.selector && host.querySelector(t.selector)) || host;
          node.innerHTML = innerOf(secs[t.section], t.selector || '.shopify-section');
        });
        document.dispatchEvent(new CustomEvent('cdd:gifts-synced', { detail: { cart: cart } }));
      });
  }

  var running = false, again = false, timer = null, burst = [];
  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(run, delay == null ? 120 : delay);
  }
  function run() {
    if (running) { again = true; return; }
    running = true;
    origFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var p = plan(cart);
        if (!p.updates && !p.adds.length) return null;
        // Freno anti-bucle: como mucho 4 sincronizaciones con cambios cada 10 s.
        var now = Date.now();
        burst = burst.filter(function (t) { return now - t < 10000; });
        if (burst.length >= 4) { console.warn('[cdd-gifts] sync paused (too many changes)'); return null; }
        burst.push(now);
        var chain = Promise.resolve();
        if (p.updates) chain = chain.then(function () { return jpost('cart/update.js', { updates: p.updates }); });
        if (p.adds.length) chain = chain.then(function () { return jpost('cart/add.js', { items: p.adds }); });
        return chain
          .then(function () { return origFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (c2) { return rerender(c2); });
      })
      .catch(function (err) { console.warn('[cdd-gifts] sync failed', err); })
      .then(function () {
        running = false;
        if (again) { again = false; schedule(50); }
      });
  }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (CART_RE.test(url)) {
      p.then(function () { schedule(); }, function () {});
    }
    return p;
  };

  window.CDDGifts.sync = function () { schedule(0); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(600); });
  } else {
    schedule(600);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(100); });
})();
